export default "__VITE_ASSET__BccCGVyz__"